import { queryOptions } from '@tanstack/react-query';

import { getConnectedAppQuery, getConnectedAppsQuery } from './shared';

export const getConnectedAppQueryOptions = (id: string) => queryOptions(getConnectedAppQuery(id));
export const getConnectedAppsQueryOptions = () => queryOptions(getConnectedAppsQuery());
